<div class="camera-container tds-u-flex tds-u-flex-dir-col tds-u-align-center">
  <h3
    class="camera-status-message tds-headline-04 tds-u-mb3 tds-text-center"
    [class.recognition-error]="isRecognitionError"
    [attr.role]="isRecognitionError ? 'alert' : 'status'"
    aria-live="assertive"
  >
    {{ cameraStatusMessage }}
  </h3>

  @if (!previewUrl) {
    <div class="video-wrapper">
      <video #videoElement autoplay playsinline muted></video>
      <div
        #faceGuide
        class="face-guide"
        [class.is-aligned]="isFaceAligned"
        aria-hidden="true"
      ></div>
    </div>
  } @else {
    <div class="preview-wrapper">
      <img class="image-preview" [src]="previewUrl" alt="Foto capturada" />
    </div>
  }

  <canvas #canvasElement style="display: none"></canvas>
</div>
